var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function attachAllBindings(comp, postUpdateCallback) {
    return __awaiter(this, void 0, void 0, function* () {
        const store = yield comp.getStore();
        const stateCallbackMap = new Map();
        const pathMap = comp.constructor._reduxStatePaths;
        for (const prop of pathMap.keys()) {
            const path = pathMap.get(prop);
            if (path) {
                stateCallbackMap.set(prop, (state) => {
                    const value = getStateValueByPath(state, path);
                    const component = comp;
                    if (value !== component[prop]) {
                        // console.log(path, ['ble satt:', value, 'fra', c[prop]]);
                        component[prop] = value;
                    }
                    else {
                        //console.log(path, 'ikke endret:', value);
                    }
                });
            }
            else {
                console.error('Ingen path å binde til på property ' + prop);
            }
        }
        const updateValuesFromState = () => {
            const state = store.getState();
            stateCallbackMap.forEach((stateCallback) => stateCallback(state));
            if (postUpdateCallback) {
                postUpdateCallback();
            }
        };
        // Initialize to current values
        updateValuesFromState();
        // Subscribe for future changes
        return {
            unsubcb: store.subscribe(updateValuesFromState),
            map: stateCallbackMap,
        };
    });
}
export function releaseAllBindings(_comp, bindDataPromise) {
    return __awaiter(this, void 0, void 0, function* () {
        //console.log('releaseAllBindings');
        const bindData = yield bindDataPromise;
        bindData.unsubcb();
        for (const _key in bindData.map.keys()) {
            // void
        }
    });
}
export function getStateValueByPath(state, path) {
    const properties = Array.isArray(path) ? path : path.split('.');
    return properties.reduce((prev, curr) => {
        if (prev && curr in prev) {
            return prev[curr];
        }
        return undefined;
    }, state);
}
function legacyReduxBind(path, proto, name) {
    // void
    const componentConstructor = proto.constructor;
    if (typeof name === 'number') {
        name = name.toString();
    }
    if (typeof name === 'string') {
        commonReduxBind(path, componentConstructor, name);
        return;
    }
    throw new Error('Bad arguments');
}
function commonReduxBind(path, componentConstructor, name) {
    if ('_reduxStatePaths' in componentConstructor &&
        componentConstructor._reduxStatePaths instanceof Map &&
        typeof name === 'string') {
        const statePathMap = componentConstructor._reduxStatePaths;
        statePathMap.set(name, path);
    }
    else {
        console.error('Failed to bind property ' + name + ' to redux-path ' + path + ' in ', componentConstructor);
    }
}
function standardReduxBind(path, classElement) {
    // void
    console.error('standardReduxBind is not implemented', [path, classElement]);
}
export function reduxBind(path) {
    //console.log('@reduxBind(' + path + '): I ytre funksjon', arguments);
    return (protoOrDescriptor, name) => name !== undefined
        ? legacyReduxBind(path, protoOrDescriptor, name)
        : standardReduxBind(path, protoOrDescriptor);
}
